import React, { useEffect } from "react";

const Legales = () => {
    useEffect(() => {
        let legalesPixel = document.createElement("div");
        legalesPixel.className = 'legales';
        
        legalesPixel.innerHTML = `
        <div class="legales__icon active">
        <button onclick="displayContent();">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" viewBox="0 0 32 32"><defs><clipPath id="clip-pathEng"><rect id="Rectángulo_2185" data-name="Rectángulo 2185" width="32" height="32" fill="#fff"/></clipPath></defs><g id="Grupo_8089" data-name="Grupo 8089" transform="translate(4.642 2.254)"><g id="Grupo_8094" data-name="Grupo 8094" transform="translate(-4.642 -2.254)" clip-path="url(#clip-pathEng)"><path id="Trazado_11873" data-name="Trazado 11873" d="M32,19.234V12.766H27.288a11.587,11.587,0,0,0-.986-2.443l3.352-3.352L25.029,2.346,21.677,5.7a13.242,13.242,0,0,0-2.443-.982V0H12.766V4.627a11.432,11.432,0,0,0-2.442.987L6.971,2.262,2.346,6.887,5.7,10.24a13.259,13.259,0,0,0-.982,2.442H0V19.15H4.627a11.482,11.482,0,0,0,.987,2.443L2.262,24.945,6.887,29.57l3.353-3.353a13.212,13.212,0,0,0,2.442.982V32H19.15V27.288a11.476,11.476,0,0,0,2.443-.986l3.352,3.352,4.625-4.625-3.353-3.352a13.242,13.242,0,0,0,.982-2.443Zm-5.531-.522a12.3,12.3,0,0,1-1.137,2.841l-.151.275,3.2,3.2-3.438,3.438-3.2-3.2-.275.15a10.817,10.817,0,0,1-2.833,1.135l-.326.076V31.16H13.522V26.548l-.318-.079a12.276,12.276,0,0,1-2.84-1.137l-.276-.151-3.2,3.2L3.449,24.945l3.2-3.2-.15-.275a10.763,10.763,0,0,1-1.136-2.834l-.076-.325H.84V13.522H5.368l.079-.318a12.288,12.288,0,0,1,1.137-2.841l.15-.275-3.2-3.2L6.971,3.449l3.2,3.2.275-.15A10.793,10.793,0,0,1,13.28,5.364l.326-.076V.84h4.787V5.368l.318.079a12.311,12.311,0,0,1,2.841,1.137l.275.15,3.2-3.2,3.438,3.438-3.2,3.2.15.275a10.788,10.788,0,0,1,1.135,2.833l.076.326H31.16v4.787H26.548ZM15.958,10.079a5.879,5.879,0,1,0,5.879,5.879,5.886,5.886,0,0,0-5.879-5.879m0,10.919A5.039,5.039,0,1,1,21,15.958,5.044,5.044,0,0,1,15.958,21" transform="translate(0 0)" fill="#fff"/></g></g></svg>
        </button>
        </div>
        <div class="legales__info ">
        <div class="legal-overlay" onclick="displayIcon();"></div>
        <div class="legales__info--box">
            <div class="legales__info--box--in">
            <div class="legal__close">
                <button onclick="displayIcon();">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.975" height="13.973" viewBox="0 0 13.975 13.973"><path id="x" d="M18.521,6.344l-5.241,5.24L8.04,6.344,6.293,8.091l5.24,5.24-5.24,5.24L8.04,20.317l5.24-5.24,5.241,5.24,1.747-1.747-5.24-5.24,5.24-5.24Z" transform="translate(-6.293 -6.344)" fill="#fff"/></svg>
                </button>
            </div>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="69" height="24" viewBox="0 0 65.172 22.845"><defs><style>.cls-1 {fill: #ffffff;}</style></defs><g id="cf1fb765e00684515d1fc1d6487baae4" transform="translate(0 -11.548)"><path id="Trazado_1125" class="cls-1" d="M28.393,159.644c4.735-3.219,9.437-3.225,14.152-.02,4.7-3.205,9.4-3.2,14.158.02a11.272,11.272,0,0,1,9.091-2.2,10.976,10.976,0,0,1,6.9,4.17A11.406,11.406,0,0,1,56.7,177.64c-4.722,3.219-9.423,3.239-14.158.027-4.688,3.205-9.4,3.212-14.145-.02a11.413,11.413,0,1,1,0-18Zm30.172,16.067a8.759,8.759,0,1,0,.007-14.125,11.5,11.5,0,0,1-.007,14.125ZM26.524,161.586a8.756,8.756,0,1,0,.007,14.118,11.444,11.444,0,0,1-2.427-7.043A11.3,11.3,0,0,1,26.524,161.586Zm3.8.007a11.466,11.466,0,0,1-.007,14.118,8.658,8.658,0,0,0,10.315-.02,11.343,11.343,0,0,1-2.434-7.043,11.219,11.219,0,0,1,2.441-7.063A8.657,8.657,0,0,0,30.328,161.592ZM44.44,175.7a8.66,8.66,0,0,0,10.281.033c-3.219-4.728-3.232-9.443,0-14.178a8.648,8.648,0,0,0-10.275.04A11.422,11.422,0,0,1,44.44,175.7Zm-1.9-1.9a8.555,8.555,0,0,0,0-10.275A8.616,8.616,0,0,0,42.538,173.8Zm14.112-10.3a8.657,8.657,0,0,0,.013,10.295A8.6,8.6,0,0,0,56.65,163.494ZM28.433,173.809a8.65,8.65,0,0,0-.007-10.308A8.628,8.628,0,0,0,28.433,173.809Z" transform="translate(-9.963 -145.677)"></path></g></svg>
            </div>
            
            <br/>
            <br/>
            <div>
                <span class="legal-title">Configuración de cookies</span>
            </div>
            <p class="legal-p sub">
                Modo consentimiento. Puedes modificar la configuración de tus preferencias.
            </p>
            <div>
                <button class="legal_button_p" style="cursor: pointer;" onclick="displayIcon();displayConsentMode();">Conoce más</button>
            </div>
            </div>
            </div>
        </div>`;

        //$("body").append(legalesPixel);
        document.body.appendChild(legalesPixel);

        const exampleScriptLegales = getScriptLegalesContent(`
        <script>
            function displayContent(){
                let legales__icon = document.getElementsByClassName("legales__icon");
                legales__icon[0].classList.remove("active");

                let legales__info = document.getElementsByClassName("legales__info");
                legales__info[0].classList.add("active");
            }   
            function displayIcon(){

                let legales__info = document.getElementsByClassName("legales__info");
                legales__info[0].classList.remove("active");

                let legales__icon = document.getElementsByClassName("legales__icon");
                legales__icon[0].classList.add("active");
            }   
        </script>
        `),
        s_Legales = document.createElement("script"),
        t_Legales = document.createTextNode(exampleScriptLegales);

        s_Legales.appendChild(t_Legales);

        document.getElementsByTagName("head")[0].appendChild(s_Legales);

        function getScriptLegalesContent(htmlStr) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = htmlStr;
            return tempDiv.innerText;
        }
    }, []);
    

    return (<></>);
};

export default Legales;